import React from "react";
import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Dash from "../../../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../../../components/RowValue/RowBody";

function KoeffizientNachWenz({ koeffizientNachWenz = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterSoil.bucklingCoefficientWenz")}</p>}
      indicesValue={
        <span>
          k<sub>c</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(koeffizientNachWenz)}</span>}
      unitValue={<Dash />}
    />
  );
}

export default KoeffizientNachWenz;
